'use strict';

partnershipsService.$inject = ["Partnership", "$http", "api", "PartnershipOverview", "PartnershipDetail", "Enums", "authService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.partnershipsService = partnershipsService;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function partnershipsService(Partnership, $http, api, PartnershipOverview, PartnershipDetail, Enums, authService) {

    return {
        getAllTemp: getAllTemp,
        // getPartnershipsForSellerHomepage: getPartnershipsForSellerHomepage,
        getAll: getAll,
        getById: getById,
        init: init,
        getGallerySliderSettings: getGallerySliderSettings
    };

    function init(pageSize) {
        return PartnershipOverview.create(pageSize);
    }

    function getAllTemp(model) {
        return $http.get('/assets/data/partnerships.json').then(function (resource) {
            _lodash2.default.map(resource.data.results, function (result) {
                model.partnerships.push(result);
            });
            model.isLoadingInitial = false;
            model.isLoading = false;
            model.paging.totalItems = resource.data.count;
            model.paging.update(1);
            return model;
        });
    }

    function getAll(model, searchRequest, page) {

        model.errorOccurred = false;
        model.isLoadingInitial = true;

        var params = {
            skip: model.paging.getSkipValue(page, searchRequest.take),
            take: searchRequest.take,
            sellerId: searchRequest.sellerId,
            title: searchRequest.title
        };

        return api.partnerships.list(params).$promise.then(function (resource) {
            _lodash2.default.map(resource.results, function (result) {
                model.partnerships.push(result);
            });
            model.isLoadingInitial = false;
            model.isLoading = false;
            model.paging.totalItems = resource.count;
            model.paging.update(page);
            model.paging.page = page;
            return model;
        }).catch(function () {
            model.isLoadingInitial = false;
            model.errorOccurred = true;
            return model;
        });
    }

    function getById(id) {
        return api.partnerships.get({ id: id }).$promise.then(function (resource) {
            if (authService.isSeller) {
                return PartnershipDetail.create(resource);
            }
            return api.shoppingCartProducts.get({}).$promise.then(function (cartProducts) {
                return PartnershipDetail.create(resource, cartProducts);
            });
        });
    }

    function getGallerySliderSettings() {
        return Enums.partnershipGallerySliderSettings;
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/partnershipsService.js
// module id = 822
// module chunks = 0